import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PonchoUIModule } from '@poncho/ui';

import { HomeModule } from '@app/home-page/home-page.module';

import { AddAddressComponent } from './components/add-address/add-address.component';
import { ProductViewComponent } from './components/product-view/product-view.component';

import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { CancelOrderConfirmationComponent } from './components/cancel-order-confirmation/cancel-order-confirmation.component';
import { DeliverLaterPopUpComponent } from './components/deliver-later-pop-up/deliver-later-pop-up.component';
import { AddressViewComponent } from './components/address-view/address-view.component';
import { GoogleMapComponent } from '@core/components/google-map/google-map.component';
import { MenuLoaderComponent } from './components/dummy-template/menu-loader/menu-loader.component';
import { MultiBrandPassModalComponent } from './components/multi-brand-pass-modal/multi-brand-pass-modal.component';
import { RiderTipComponent } from './components/rider-tip/rider-tip.component';
import { InstallEatclubComponent } from './components/install-eatclub/install-eatclub.component';
import { FloatingViewComponent } from './components/floating-view/floating-view.component';
import { BillDetailsComponent } from './components/bill-details/bill-details.component';

import { ToggleInputDirective } from './directives/toggle-input.directive';
import { MatchHeightDirective } from './directives/match-height.directive';
import { PaymentModule } from '@poncho/payments';
import { CouponAnimationComponent } from './components/coupon-animation/coupon-animation.component';
import { FreebieDialogComponent } from './components/freebie-dialog/freebie-dialog.component';
import { ProfileSectionComponent } from '@app/modules/customer/profile-components/profile-section/profile-section.component';
import { CustomerSidebarComponent } from '@app/modules/customer/profile-components/customer-sidebar/customer-sidebar.component';
import { RepeatCustomizationComponent } from './components/customization/repeat-customization/repeat-customization.component';
import { RepeatCustomizationBottomSheetComponent } from './components/customization/repeat-customization-bottom-sheet/repeat-customization-bottom-sheet.component';
import { SharingOptionsComponent } from '@app/modules/refer/components/sharing-options/sharing-options.component';
import { PlayWinRepeatComponent } from './components/play-win-repeat/play-win-repeat.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatToolbarModule,
        MatStepperModule,
        MatTabsModule,
        MatExpansionModule,
        MatButtonToggleModule,
        MatChipsModule,
        MatTooltipModule,
        ScrollingModule,
        MatBottomSheetModule,
        HomeModule,
        PaymentModule,
        AddAddressComponent,
        ProductViewComponent,
        InfoDialogComponent,
        CancelOrderConfirmationComponent,
        ToggleInputDirective,
        MatchHeightDirective,
        DeliverLaterPopUpComponent,
        AddressViewComponent,
        GoogleMapComponent,
        MenuLoaderComponent,
        RiderTipComponent,
        MultiBrandPassModalComponent,
        InstallEatclubComponent,
        FloatingViewComponent,
        BillDetailsComponent,
        CouponAnimationComponent,
        FreebieDialogComponent,
        ProfileSectionComponent,
        CustomerSidebarComponent,
        RepeatCustomizationComponent,
        RepeatCustomizationBottomSheetComponent,
        SharingOptionsComponent,
        PlayWinRepeatComponent,
        PrivacyPolicyComponent
    ],
    exports: [
        RouterModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatToolbarModule,
        MatStepperModule,
        MatTabsModule,
        MatExpansionModule,
        MatButtonToggleModule,
        MatChipsModule,
        MatBottomSheetModule,
        MatTooltipModule,
        ScrollingModule,
        ProductViewComponent,
        ToggleInputDirective,
        MatchHeightDirective,
        PonchoUIModule,
        AddressViewComponent,
        HomeModule,
        MenuLoaderComponent,
        RiderTipComponent,
        MultiBrandPassModalComponent,
        InstallEatclubComponent,
        BillDetailsComponent,
        ProfileSectionComponent,
        CustomerSidebarComponent,
        SharingOptionsComponent
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
